import React from 'react';
import { momentParseDate } from '../../../helpers';

interface Props {
    salesInvoice: any;
}

const SalesInvoiceCondition = ({ salesInvoice }: Props) => {
    const isTwoPayments = (salesInvoice?.number_of_payments || 1) === 2;

    return (
        <div className="sales-invoice-condition">
            <div className="row">
                {/* Método de pago */}
                <div className="col-md-3">
                    <div className="form-group mb-3">
                        <label htmlFor="paymentMethod">Método de pago:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={salesInvoice?.payment_method_name || salesInvoice?.payment_method || ''}
                            disabled
                        />
                    </div>
                </div>

                {isTwoPayments ? (
                    <>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label>1er pago ({salesInvoice?.payment_1_percentage || 0}%):</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={`${salesInvoice?.payment_condition_name || ''} - ${salesInvoice?.days ?? ''} días - Vence: ${momentParseDate(salesInvoice?.due_date || '')}`}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label>2do pago ({salesInvoice?.payment_2_percentage || 0}%):</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={`${salesInvoice?.payment_2_condition_name || ''} - ${salesInvoice?.payment_2_days ?? ''} días - Vence: ${momentParseDate(salesInvoice?.due_date_2 || '')}`}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="col-md-3">
                            <div className="form-group mb-3">
                                <label htmlFor="paymentCondition">Condición de pago:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={salesInvoice?.payment_condition_name || salesInvoice?.payment_condition || ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group mb-3">
                                <label htmlFor="paymentDays">Días:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={salesInvoice?.days !== undefined && salesInvoice?.days !== null ? salesInvoice.days : ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group mb-3">
                                <label htmlFor="dueDate">Fecha de vencimiento:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={momentParseDate(salesInvoice?.due_date || '')}
                                    disabled
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SalesInvoiceCondition;
